import { ReportEmailDeliveryMethod } from './report-email-delivery-method';

export class ReportDeliveryMethod {
    report_email: ReportEmailDeliveryMethod;

    constructor(json: any) {
        this.report_email = json.report_email ? new ReportEmailDeliveryMethod(json.report_email) : null;
    }
}
